export const exportHeaders = [
    {
        label: "Member ID",
        key: "loyalty_id"
    },

    {
        label: "Billto",
        key: "customer_billto_account_number"
    },


    {
        label: "Shipto",
        key: "customer_account_number"
    },

    {
        label: "Start Date",
        key: "startup_start_date"
    },

    {
        label: "End Date",
        key: "startup_end_date"
    },
    {
        label: "Initiated By",
        key: "altered_by"
    },
    {
        label: "Updated By",
        key: "user_name"
    }

    
]